import { useNavigate } from 'react-router';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { JonumVerifiedView } from '@sorare/core/src/components/jonum/JonumVerifiedDialog/JonumVerifiedView';
import { ANY_SPORT_HOME } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { LIFECYCLE, useLifecycle } from '@sorare/core/src/hooks/useLifecycle';

const PageRoot = styled(Vertical).attrs({ gap: 0 })`
  min-height: var(--100vh);
`;

const JonumVerifiedPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { isIosApp, postMessage } = useIsMobileApp();
  const navigate = useNavigate();
  const { update } = useLifecycle();

  const close = async () => {
    await update(LIFECYCLE.sawJonumVerifiedDialog, true);
    if (isIosApp) {
      postMessage('closeCurrentWebview');
    } else {
      navigate(generateSportContextPath(ANY_SPORT_HOME));
    }
  };

  return (
    <PageRoot>
      <JonumVerifiedView onConfirm={close} />
    </PageRoot>
  );
};

export default JonumVerifiedPage;
